import { UNIT_OF_MEASURE } from "segments/desktop/pricing/constants";
export default {
    currencyValue: "usd",
    signupButtonText: "signup.tryForFree",
    contactUsButtonText: "footer.contactUs",
    defaultSeatsIndex: 0,
    unitOfMeasure: UNIT_OF_MEASURE.SEATS
};
